export default __webpack_public_path__ + "static/media/img-61.23a7da16.jpg";